import { useEffect } from 'react';
import { IHistoryState } from '../types/history';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../types/redux';
import { fetchBuildersProjects } from '../actions/buildersProjects';
import { replaceSavedFilters } from '../actions/filters';
import { selectPagination } from '../selectors/pagination';
import { DEFAULT_PAGE } from '../constants/pagination';

export const useHistoryListener = () => {
  const { page: currentPage } = useSelector(selectPagination, shallowEqual);
  const dispatch = useDispatch<TThunkDispatch>();

  useEffect(() => {
    const refreshPageHandler = ({ state }: PopStateEvent) => {
      const { filters = {}, page = DEFAULT_PAGE } = (state || {}) as IHistoryState;

      dispatch(replaceSavedFilters(filters));
      dispatch(fetchBuildersProjects({ filters, page, shouldUpdateUrl: false }));
    };

    window.addEventListener('popstate', refreshPageHandler, false);

    return () => {
      window.removeEventListener('popstate', refreshPageHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
};
